import { render, staticRenderFns } from "./shareDetailBar.vue?vue&type=template&id=0a8c8d7c&scoped=true&"
import script from "./shareDetailBar.vue?vue&type=script&lang=js&"
export * from "./shareDetailBar.vue?vue&type=script&lang=js&"
import style0 from "./shareDetailBar.vue?vue&type=style&index=0&id=0a8c8d7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8c8d7c",
  null
  
)

export default component.exports